import { parcelStatusText } from '../../parcelStatus';
import { AmazonParcel } from './query';

export const amazonStatusColorScheme: Record<string, string> = {
  INBOUND: 'grey',
  READY_FOR_CONSIGNEE_PICKUP: 'yellow',
  READY_FOR_UPS_PICKUP: 'yellow',
  AWAITS_DRIVER_PICKUP: 'yellow',
  DISPOSSESSIONS: 'green',
  UNKNOWN: 'purple',
};

export const amazonParcelStatusText = parcelStatusText;

export const hubCounterLabel = (parcel: Pick<AmazonParcel, 'hubCounterID' | 'amazonAccessPointId'>) =>
  parcel.hubCounterID || parcel.amazonAccessPointId;

export const canConsigneePickup = (parcel: Pick<AmazonParcel, 'deliveryStatus' | 'notInInventorySync' | 'consigneePickupAckAt'>) =>
  (parcel.deliveryStatus === 'READY_FOR_CONSIGNEE_PICKUP' || parcel.deliveryStatus === 'READY_FOR_UPS_PICKUP') &&
  !parcel.notInInventorySync &&
  !parcel.consigneePickupAckAt;

export const canAgedParcelScan = (parcel: Pick<AmazonParcel, 'deliveryStatus' | 'notInInventorySync' | 'agedParcelScanAckAt'>) =>
  parcel.deliveryStatus === 'READY_FOR_UPS_PICKUP' && !parcel.notInInventorySync && !parcel.agedParcelScanAckAt;

export const amazonManualEntryTooltip = (
  parcel: Pick<AmazonParcel, 'pickupCodeEnteredManually' | 'trackingCodeEnteredManually'>
): string | null => {
  const pickup = Boolean(parcel.pickupCodeEnteredManually);
  const tracking = Boolean(parcel.trackingCodeEnteredManually);
  if (pickup && tracking) return 'Abholcode und Trackingcode manuell eingegeben';
  if (pickup) return 'Abholcode manuell eingegeben';
  if (tracking) return 'Trackingcode manuell eingegeben';
  return null;
};
